function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_270",
  "data-name": "Path 270",
  d: "M80.552,114.909H61.766a.743.743,0,0,0-.557.186.631.631,0,0,0-.186.557l1.93,16.818a3.675,3.675,0,0,0,3.675,3.23h9.356a3.675,3.675,0,0,0,3.713-3.341l1.6-16.781a.631.631,0,0,0-.186-.483A.742.742,0,0,0,80.552,114.909Zm-2.339,17.375a2.153,2.153,0,0,1-2.228,1.93H66.63a2.116,2.116,0,0,1-2.19-1.893l-1.856-15.927H79.735Z",
  transform: "translate(-58.313 -106.741)",
  fill: "#535765"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_273",
  "data-name": "Path 273",
  d: "M47.941,3.342H40.293V2.154A2.079,2.079,0,0,0,38.29,0q-.056,0-.113,0H33.5a2.079,2.079,0,0,0-2.117,2.04q0,.056,0,.113V3.341H23.736a.743.743,0,1,0,0,1.485H47.941a.742.742,0,1,0,0-1.485ZM38.808,2.154V3.341h-5.94V2.154a.594.594,0,0,1,.631-.668h4.678a.594.594,0,0,1,.634.551A.587.587,0,0,1,38.808,2.154Z",
  transform: "translate(-22.993 0)",
  fill: "#535765"
});

function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_372",
    "data-name": "Group 372",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.691,
    height: 28.958,
    viewBox: "0 0 25.691 28.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/TrashIcon.bc53d997.svg";
export { ForwardRef as ReactComponent };